import React from "react";
import "../../Style/formik_style.css";
import {
  FormControl,
  InputLabel,
  Select,
  useTheme,
} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import { tokens, ColorModeContext } from "../../../../theme";
import { useEffect } from "react";
import { useState } from "react";
// import './style.css'

function SelectNew(props) {
  const { name, label, options, disabled, values,setFieldValue, ...rest } = props;
  const theme = useTheme();
  const colora = tokens(theme.palette.mode);
  const sxStyle = {
    color: "#fff",
    borderRadius: "4px",
    padding: "8px",
    textAlign: "center",
    width: "100%",
    "& .MuiInputLabel-outlined": { color: "gray !important" },
  };
  const [value, setValue] = useState("");
  useEffect(() => {
    setValue(values ? values : "");
  }, [values,name,setFieldValue]);
  const handleChange = (e) => {
    setValue(e.target.value);
   setFieldValue(name, e.target.value);
  };
  return (
    // <Field name={name}>
    //   {({ field, form }) => {
       /// return (
         
          <FormControl
            size="small"
            sx={sxStyle}
            className="custom-filter custom-filter-data font-num "
          >
            <InputLabel
              id={name}
              variant="outlined"
              className="font-num"
              sx={{
                //color: form.errors[name] && form.touched[name] ? "red" : "gray",
                color:"gray",
                fontSize: "9 rem",
                textAlign: "right",
              }}
              htmlFor={name}
            >
              {label}
            </InputLabel>

            <Select
             // {...field}
              //error={form.errors[name] && form.touched[name]}
              label={label}
              variant="outlined"
              value={value}
              // defaultValue={values ? values : ""}
              name={name}
              id={name}
              {...rest}
              size="small"
              disabled={disabled}
             onChange={(e) => handleChange(e)}
            >
              {options &&
                options.map((option, index) => {
                  return (
                    <MenuItem
                      sx={{
                        fontSize: "0.7rem",
                        background: "transparent",
                        border: "none",
                      }}
                      key={index}
                      value={option?.value || ""}
                    >
                      {option?.key}
                    </MenuItem>
                  );
                })}
            </Select>
          </FormControl>
        );
    //   }}
    // </Field>
 // );
}

export default SelectNew;


 // <Field
          //   name={name}
          //   as="select"
          //   className="custom-select"
          //   style={{
          //     width: "100%",
          //     flex: "1",
          //     display: "flex",
          //     height: "100%",
          //     padding: "0.5rem 0",
          //     background:theme.palette.mode==="dark"? "#262D39": "#F7FBFF",
          //     borderColor: "#b1d5fd",
          //     borderRadius: "4px",
          //     margin:'0 4px',
          //     color:theme.palette.mode==="dark"?'#C7C8CC':'#353841'
          //   }}
          // >
          //   {options.map((option, index) => {
          //     return (
          //       <option key={option.key} value={option.value} className="custom-select-option" style={{padding: '8px !important',margin:'0.5rem', fontSize: '1rem'}}>
          //         {option.key}
          //       </option>
          //     );
          //   })}
          // </Field>
